import { useContext } from "react";
import { ThemeContext } from "../context/Theme/ThemeContext";

/**
 * Tema do app (topbar / tailwick-app). Preferir isto ao localStorage em layouts Tailwick.
 */
export default function useAppDarkMode() {
	const { darkMode } = useContext(ThemeContext);
	return Boolean(darkMode);
}
